import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"

const Container = styled.div`
  background-color: ${greys.lightest};
  padding: ${padding.small};
  margin: 0 -${padding.small} ${padding.small};
  font-size: 16px;

  ${minWidthMedia.tablet`
    margin: 0 -${padding.medium} ${padding.base};
    padding: ${padding.base} ${padding.medium};
    font-size: 20px;
  `}
`

const ImportantInfo = ({children}) => {
  return <Container>{children}</Container>
}

ImportantInfo.propTypes = {
  children: PropTypes.any.isRequired
}

export default ImportantInfo
